import React from "react";
import { Instagram, Youtube, Music2, Music, Disc } from "lucide-react";

const SOCIALS = [
  { id: "instagram", icon: Instagram, label: "Instagram", href: "https://www.instagram.com/concept.and.formality" },
  { id: "youtube", icon: Youtube, label: "YouTube", href: "https://youtube.com/@conceptsama8453" },
  { id: "bandcamp", icon: Disc, label: "Bandcamp", href: "https://conceptandformality.bandcamp.com" },
  { id: "tiktok", icon: Music2, label: "TikTok", href: "https://www.tiktok.com/@conceptandformality" },
  { id: "spotify", icon: Music, label: "Spotify", href: "#" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 overflow-hidden mt-12">
      <div className="absolute inset-0 synth-grid opacity-20 pointer-events-none" aria-hidden="true" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-[#FF00E5]/15 blur-[120px] pointer-events-none" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-10 pt-20 md:pt-28 pb-10">
        {/* Massive wordmark */}
        <div className="text-center">
          <h2 className="font-display font-black text-[22vw] md:text-[16vw] lg:text-[14vw] leading-[0.85] text-gradient-neon select-none">
            C.A.F.
          </h2>
          <p className="font-mono-display text-xs md:text-sm uppercase tracking-[0.4em] text-white/55 -mt-2 md:-mt-4">
            Concept And Formality
          </p>
        </div>

        {/* Socials */}
        <div className="mt-14 flex flex-wrap justify-center gap-3 md:gap-4">
          {SOCIALS.map((s) => (
            <a
              key={s.id}
              data-testid={`social-${s.id}`}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              className="group flex items-center gap-3 px-5 py-3 border border-white/15 hover:border-[#00F0FF] bg-black/40 hover:glow-cyan transition-all"
            >
              <s.icon size={16} className="text-white/70 group-hover:text-[#00F0FF] transition-colors" />
              <span className="font-mono-display text-[10px] uppercase tracking-[0.25em] text-white/70 group-hover:text-[#00F0FF] transition-colors">
                {s.label}
              </span>
            </a>
          ))}
        </div>

        {/* Bottom row */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-[10px] font-mono-display uppercase tracking-[0.25em] text-white/40">
          <span>© 2026 Concept And Formality · Stephen Austin · Las Vegas</span>
          <a
            data-testid="footer-business-email"
            href="mailto:Conceptandformalityllc@gmail.com"
            className="hover:text-[#00F0FF] transition-colors normal-case tracking-normal text-xs"
          >
            Conceptandformalityllc@gmail.com
          </a>
          <div className="flex items-center gap-4">
            <a
              data-testid="footer-admin-link"
              href="/admin"
              className="hover:text-[#FF00E5] transition-colors"
            >
              Admin
            </a>
            <span className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#FF00E5] animate-pulse" />
              Album incoming
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
